import { COMPANY, companyAddress } from '@amumin/domain';
import { t } from '@amumin/i18n';

import { appHost, kioskHost } from '../lib/addresses.js';
import { appText } from '../state/session.js';

/**
 * Bedrijfsgegevens van AMUMIN B.V. (art. 3:15d BW), uit één plek (packages/domain/src/company.ts).
 * Rustig en klein: bij Instellingen, onder de privacyverklaring en onder de inlogschermen.
 * `where`: ook de regel "de app staat op amumin.app, het bord op board.amumin.app" (zodat mensen
 * leren alleen op amumin.app in te loggen) en de tip om een oude beginscherm-app van f.amumin.com
 * te vervangen (op iOS werken meldingen alleen vanaf het beginscherm).
 */
export function CompanyDetails({ where = false }: { where?: boolean }) {
  const c = appText.value.domein.company;
  return (
    <div class="company-details" data-name="company-details">
      {where ? (
        <p class="muted small" data-name="company-where">
          {t(c.where, { app: appHost(), board: kioskHost(appHost()) })}
        </p>
      ) : null}
      {where ? (
        <p class="muted small" data-name="company-home-screen">
          {t(appText.value.domein.homeScreen, { app: appHost() })}
        </p>
      ) : null}
      {/* Fijnslijpen (7 okt 2026): de onderdelen als losse blokjes met ruimte ertussen, niet met " · "
          (een punt bleef aan het eind of begin van een regel hangen). */}
      <address class="muted small company-address" aria-label={c.title}>
        <span>{COMPANY.name}</span>
        <span>{t(c.kvk, { kvk: COMPANY.kvk })}</span>
        <span>{companyAddress()}</span>
        <span>
          {c.contact} <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        </span>
      </address>
    </div>
  );
}
